class CustomerDisplayMediaController extends AbstractEntityEditController
	@register()
	@inject '$uibModal',
		'$scope',
		'translate'
		'entity'
		'ShopRepository'
		'ShopGroupRepository'
		'CustomerDisplayMediaRepository'
		'CustomerDisplayMediaFileRepository'
		'ConfigurationService'
		'MessageTerminal'
		'Guid'
		'BACKEND_CUSTOMER_DISPLAY_MEDIA_ENTITY_TYPE'

	initialize: ->
		@mainCrud.entityType = 'general.customer_display.media'
		@mainCrud.entityTitle = 'general.customer_display.media.new'

		@mediaFileActions = []

		@entityTypes = []
		@shopGroupsEnabled = @ConfigurationService.isEnabled 'Backoffice.ShopManagement.Shops.EnableShopGroups'

		for key, type of @BACKEND_CUSTOMER_DISPLAY_MEDIA_ENTITY_TYPE
			@entityTypes.push {
				name: @translate('general.customer_display.type.' + type.toLowerCase())
				entity_type: type
			}

		if !@mainCrud.isNewEntity
			@mainCrud.entityTitle = @entity.name

			for mediaFile in @entity.files
				mediaFile.order = parseInt(mediaFile.order)
		else
			@entity =
				entity_type: @BACKEND_CUSTOMER_DISPLAY_MEDIA_ENTITY_TYPE.LOGGED_IN
				is_active: '1'
				duration: '10000'
				files: []

		@mainCrud.additionalButtons = [
			{
				action: 'add-file'
				label: 'general.customer_display.media.file.add'
				click: => @editMediaFile()
				icon: 'fa fa-plus-circle'
				visible: false
			}
		]
		@mainCrud.tabs = [
			{
				id: 'details'
				title: 'general.details'
				selector: '#tab-details'
			}
			{
				id: 'files'
				title: 'general.customer_display.media.files'
				selector: '#tab-files'
			}
		]
		@MessageTerminal.on(
			@$scope,
			@MessageTerminal.events.TAB_CHANGE,
			(tab) =>
				@mainCrud.additionalButtons[0].visible = tab.id == 'files'
		)

	save: ->
		customerDisplayMedia = angular.copy(@entity)
		delete customerDisplayMedia.files

		customerDisplayMedia.shops = _.pluck(customerDisplayMedia.shops, 'id')
		customerDisplayMedia.shop_groups = _.pluck(customerDisplayMedia.shop_groups, 'id')

		@CustomerDisplayMediaRepository
			.save customerDisplayMedia, @mainCrud.isNewEntity
			.then (response) =>
				@afterSave(response)
			.catch (response) =>
				@handleErrors response

	afterSave: (response) ->
		if _.isEmpty(@mediaFileActions)
			super(response)

			return

		@CustomerDisplayMediaFileRepository
			.all(
				@mediaFileActions.map(
					(actionData) =>
						data = _.pick(actionData, 'id', 'order', 'image')
						data.media_id = response.data.id

						if actionData.action == 'create' || actionData.action == 'update'
							return @CustomerDisplayMediaFileRepository.saveWithAttachment(data, actionData.action == 'create')

						@CustomerDisplayMediaFileRepository.delete(data.id)
				)
			)
			.then =>
				@mediaFileActions = []

				for mediaFile in @entity.files
					mediaFile.is_new = false

				super(response)
			.catch (response) =>
				@handleErrors response

	delete: ->
		@deleteEntity @CustomerDisplayMediaRepository, @entity

	deleteMediaFile: (mediaFile) ->
		@triggerFormChange()
		@addAction('delete', mediaFile)

		@entity.files = _.reject(@entity.files, {id: mediaFile.id})

	editMediaFile: (originalMediaFile = null) ->
		@$uibModal
			.open
				templateUrl: '@app/customer-display-media/modals/customer-display-media.modal.view.html'
				controllerAs: 'mediaFileModal'
				controller: ($uibModalInstance, mediaFile, ImageService) ->
					$onInit: ->
						@isValid = mediaFile.image?
						@$uibModalInstance = $uibModalInstance
						@mediaFile = angular.copy(mediaFile)
						@mediaFile.is_uploaded ?= false
						@mediaFile.image_url ?= ImageService.resize(@mediaFile.image || null)
					showPreview: ->
						@isValid = true
						@mediaFile.is_uploaded = true
						@mediaFile.image_url = URL.createObjectURL(@mediaFile.image)
				bindToController: true
				size: 'lg'
				resolve:
					mediaFile: => originalMediaFile || {id: @Guid.generate(), is_new: true, order: 0}
			.result
			.then (mediaFile) =>
				@triggerFormChange()

				if originalMediaFile == null
					@entity.files.push mediaFile

					@addAction('create', mediaFile)

					return

				originalMediaFile.image = mediaFile.image
				originalMediaFile.image_url = mediaFile.image_url
				originalMediaFile.is_uploaded = true
				originalMediaFile.is_new = mediaFile.is_new
				originalMediaFile.order = mediaFile.order

				if originalMediaFile.is_new == true
					@addAction('create', mediaFile)
				else
					@addAction('update', mediaFile)

	addAction: (actionName, mediaFile) ->
		mediaFile.action = actionName

		@mediaFileActions = _.reject(@mediaFileActions, {id: mediaFile.id})

		if mediaFile.is_new && actionName == 'delete'
			return

		@mediaFileActions.push(mediaFile)

	findShop: (searchString) ->
		return @findEntity(@ShopRepository, searchString)

	findShopGroup: (searchString) ->
		return @findEntity(@ShopGroupRepository, searchString)

	findEntity: (repository, searchString) ->
		query = repository.createQuery()
		query.criteria 'name', 'LIKE', searchString

		return repository.findByQuery query
